import { render, staticRenderFns } from "./C-3-1b__ProductInfoEdit_LandingPageURL.vue?vue&type=template&id=6482b3fe&"
import script from "./C-3-1b__ProductInfoEdit_LandingPageURL.vue?vue&type=script&lang=js&"
export * from "./C-3-1b__ProductInfoEdit_LandingPageURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports